import { Controller } from '@hotwired/stimulus'

// Swaps a lightweight play button for an <audio> element built on demand.
// The <audio> is not in the DOM until the user clicks play, so tables full
// of recordings don't allocate a media element per row (Safari performance).
export default class extends Controller {
    static targets = ['button']
    static values = {
        url: String,
        height: { type: String, default: '36px' },
    }

    play() {
        const audio = document.createElement('audio')
        audio.controls = true
        audio.autoplay = true
        audio.src = this.urlValue
        audio.style.width = '100%'
        audio.style.height = this.heightValue
        this.buttonTarget.replaceWith(audio)
    }
}
